/** 本文件由工具自动生成,请勿手动修改！ **/
// @ts-nocheck
import { useState,  useEffect } from 'react';
import * as R from 'ramda';
import Request, { YWRequestConfig } from '@ywfe/request';
import {getHost, reduceParams, parseParams, querystring} from '@ywfe/utils';



  const {basePath = '', loginPath = ''} = getHost("PRO_SETTLE", "446")





  export interface API54251Req {
  
      /** 任务ID(Long) */
      taskId?: string;
    
  };



  export interface API54251Res {
    /**   */
    code?: string;
    /**   */
    msg?: string;
    /**   */
    success?: boolean;
    /**   */
    exceptionMsg?: string;
    
  };


// 54251 /workTask/notify

export const useGetAPI54251 = () => {
  let isMount = true;
  const [isAPI54251Loading, setIsAPI54251Loading] = useState(false);
  const [dataAPI54251, setDataAPI54251] = useState<API54251Res>({} as API54251Res);
  const fetchAPI54251Data = async (inputs: API54251Req, config?: YWRequestConfig): Promise<API54251Res> => {
    
    const params = (reduceParams(inputs as unknown as R.Dictionary<API54251Req>) || {}) as API54251Req;
    
    if ( isMount ) {
      setIsAPI54251Loading(true);
    }

    try {
      
      
      const res: any = await Request.get<API54251Res>(`${basePath}/team-work/workTask/notify?${querystring.stringify(params as any)}`, {
        loginHost: loginPath,
        ...config
      });
      
      
      
      if (isMount) {
        setDataAPI54251(res || {} as API54251Res);
        setIsAPI54251Loading(false);
      }
      return res;
    } catch (error) {
      console.error('API error: ', error);
      if ( isMount ) {
        setIsAPI54251Loading(false);
      }
      return false as unknown as API54251Res;
    }
  }

  useEffect(() => {
    return () => {
      isMount = false;
    };
  }, []);

  return {
    isAPI54251Loading,
    dataAPI54251,
    fetchAPI54251Data,
  }
}

